module.exports = __webpack_public_path__ + "img/6.812ac57a.png";